export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  views: number;
  replies: number;
  likes: number;
  tags: string[];
  isHot: boolean;
  isPinned: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2024年前端开发技术趋势：React 19、Vite 6与AI驱动开发',
    excerpt: '前端技术日新月异，本文总结了2024年最值得关注的前端技术趋势，包括React 19的新特性、Vite 6的性能提升以及AI如何改变前端开发工作流。',
    content: `<p>2024年，前端开发领域迎来了诸多令人兴奋的变化。随着React 19的发布，Server Components正式成为主流，为前端性能优化开辟了全新道路。</p><p>React 19带来了多项重要更新：全新的编译器架构使得自动memoization成为可能，开发者不再需要手动使用useMemo和useCallback；Server Components的成熟让页面首次加载速度提升了40%以上；新的use() hook简化了异步数据获取的逻辑。</p><p>Vite 6在构建性能上也实现了质的飞跃。基于Rust的新一代打包器使得冷启动时间缩短至100ms以内，HMR（热模块替换）几乎无延迟。对于大型项目，构建时间相比Webpack减少了80%以上。</p><p>AI驱动开发正在改变前端工程师的工作方式。GitHub Copilot的上下文理解能力大幅提升，能够根据项目整体结构智能生成代码。Cursor等AI原生IDE让编程体验更加智能化。</p><p>值得关注的还有WebAssembly的普及，越来越多的计算密集型任务可以在浏览器中以接近原生的速度运行。WebGPU的推出为浏览器中的图形渲染带来了全新可能。</p><p>作为前端开发者，保持学习的心态至关重要。建议大家多关注官方文档和技术博客，参与开源项目，在实践中掌握这些新技术。</p>`,
    category: 'tech',
    author: '代码行者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20programmer%20avatar%20with%20glasses%20on%20simple%20light%20warm%20studio%20background%2C%20professional%20portrait%20style%2C%20minimalist%2C%20clean&width=80&height=80&seq=avatar-tech-1&orientation=squarish',
    publishDate: '2024-12-15',
    views: 35680,
    replies: 428,
    likes: 1892,
    tags: ['前端开发', 'React', 'Vite', '技术趋势'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 2,
    title: '熬夜整理：Python自动化办公终极指南',
    excerpt: '从Excel批量处理到PDF自动生成，本文将分享20个实用的Python自动化办公脚本，让你的工作效率提升10倍。',
    content: `<p>在日常办公中，有许多重复性工作可以通过Python自动化来完成。本文将分享20个经过实战检验的自动化脚本。</p><p><strong>一、Excel自动化处理</strong></p><p>使用openpyxl库可以轻松实现Excel文件的批量读写。比如批量合并多个Excel文件、自动生成报表、数据清洗等。以下是一个简单的示例：读取某个文件夹下所有的Excel文件，将它们合并到一个工作簿中。</p><p><strong>二、PDF文档处理</strong></p><p>通过PyPDF2和reportlab库，可以实现PDF的合并、拆分、加水印以及从零生成PDF文档。特别适用于需要批量生成合同、发票等场景。</p><p><strong>三、邮件自动化</strong></p><p>使用smtplib和email库可以定时发送邮件、批量发送个性化邮件，配合win32com甚至可以操作Outlook。</p><p><strong>四、文件整理</strong></p><p>自动分类、重命名文件，按照创建日期或文件类型归档到不同文件夹。</p><p><strong>五、网页数据抓取</strong></p><p>使用requests和BeautifulSoup可以定时抓取网页数据，自动生成数据报告。</p><p>这些脚本代码我都整理好了，回复可见下载链接。希望能帮助大家从重复劳动中解放出来，专注于更有价值的工作。</p>`,
    category: 'tech',
    author: 'Python达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20professional%20male%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-tech-2&orientation=squarish',
    publishDate: '2024-12-14',
    views: 28900,
    replies: 356,
    likes: 2340,
    tags: ['Python', '自动化', '办公效率'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 3,
    title: '【多图预警】今天做了道红烧排骨，全家连吃两碗饭',
    excerpt: '分享一道家常红烧排骨的做法，色泽红亮、软烂入味，厨房小白也能零失败！',
    content: `<p>周末在家闲来无事，决定做一道红烧排骨犒劳一下家人。结果一端上桌就被抢光了，连汤汁都拌着米饭吃了个精光！</p><p><strong>食材准备：</strong></p><p>猪肋排500克、葱姜蒜适量、八角2个、桂皮1小块、香叶2片、冰糖30克、生抽2勺、老抽1勺、料酒2勺、盐适量。</p><p><strong>做法步骤：</strong></p><p>1. 排骨冷水下锅，加入姜片和料酒焯水，水开后煮2分钟捞出洗净。</p><p>2. 锅中放少许油，加入冰糖小火炒至焦糖色（这一步很关键，决定成色）。</p><p>3. 放入排骨快速翻炒上色，加入葱姜蒜、八角桂皮香叶炒出香味。</p><p>4. 加入生抽、老抽、料酒，翻炒均匀后加入没过排骨的热水。</p><p>5. 大火烧开后转小火炖40分钟，最后大火收汁，撒上葱花即可。</p><p><strong>小贴士：</strong></p><p>炒糖色一定要小火，颜色变成琥珀色就可以下排骨了，炒过头会发苦。炖的时间可以适当延长，越炖越入味。</p><p>大家周末都做了什么好吃的？欢迎在评论区分享！</p>`,
    category: 'life',
    author: '厨房小能手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20home%20cook%20woman%20avatar%20portrait%20on%20warm%20kitchen%20background%2C%20friendly%20smile%2C%20simple%20minimal%20style&width=80&height=80&seq=avatar-life-1&orientation=squarish',
    publishDate: '2024-12-13',
    views: 42300,
    replies: 567,
    likes: 3456,
    tags: ['美食', '家常菜', '红烧排骨', '厨房'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 4,
    title: '年度最佳华语剧集《漫长的季节》深度解析',
    excerpt: '从叙事结构、人物塑造到时代隐喻，全方位解析这部豆瓣9.4分的现象级剧集。',
    content: `<p>《漫长的季节》无疑是2024年最具讨论度的华语剧集之一。豆瓣9.4的高分、全网热议的话题度，都证明了这部作品的非凡品质。</p><p><strong>叙事结构：三线交织的悬疑叙事</strong></p><p>该剧采用了三条时间线（1997年、1998年、2016年）交织的叙事方式。这种非线性叙事不仅增强了悬疑感，更巧妙地展现了时间的流逝对人物命运的影响。导演辛爽用极其克制的手法，让每一个转场都充满意味。</p><p><strong>人物塑造：时代洪流中的小人物</strong></p><p>范伟饰演的王响是整部剧的灵魂。一个普通的火车司机，因为儿子的死而执着于追寻真相。他的善良、固执、幽默和悲情，都被范伟演绎得淋漓尽致。秦昊饰演的龚彪则代表了另一种人生态度——看似洒脱实则充满无奈。</p><p><strong>时代隐喻：东北工业城市的变迁</strong></p><p>桦林这座虚构的东北城市，是许多中国工业城市的缩影。剧集借悬疑故事的外壳，呈现了国企改革、下岗潮等时代背景下普通人的命运。</p><p><strong>为什么能打动人心？</strong></p><p>因为它讲的是"人"的故事。在宏大的时代背景下，每个人都在努力地活着。这种真实感让观众产生了强烈的共鸣。</p><p>如果你还没看过这部剧，强烈推荐。它绝对值得你花时间细细品味。</p>`,
    category: 'entertainment',
    author: '影评人阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20film%20critic%20man%20avatar%20portrait%20with%20warm%20studio%20lighting%2C%20simple%20background%2C%20clean%20minimal%20style&width=80&height=80&seq=avatar-ent-1&orientation=squarish',
    publishDate: '2024-12-12',
    views: 56800,
    replies: 892,
    likes: 4567,
    tags: ['影视', '剧评', '漫长的季节'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 5,
    title: '【攻略】《黑神话：悟空》全Boss打法详解（持续更新）',
    excerpt: '整理了目前遇到的所有Boss的战前准备、打法要点和视频演示，助你轻松通关。',
    content: `<p>《黑神话：悟空》上线以来，无数玩家沉迷其中。作为一款高难度的动作游戏，Boss战是最大的挑战也是最大的乐趣。</p><p><strong>第一章Boss：灵虚子</strong></p><p>这是新手遇到的第一个Boss。推荐等级5级以上。灵虚子的攻击模式主要有三种：爪击连段、跳跃砸地和激光扫射。躲避的要点是保持中距离，看到抬手动作就闪避。击败后可获得重要道具"灵虚之心"。</p><p><strong>第一章Boss：广智</strong></p><p>相比灵虚子，广智的攻击更加多变。他会使用火系法术和近战连招。建议穿防火装备，在Boss释放火焰技能时果断使用定身术，然后全力输出。</p><p><strong>第二章Boss：黄风怪</strong></p><p>这是第一个真正有难度的Boss。黄风怪的风沙技能会大幅降低视野，需要靠声音判断攻击方向。建议装备增加移动速度的饰品。</p><p><strong>通用技巧：</strong></p><p>1. 熟练掌握完美闪避是通关的关键</p><p>2. 不要贪刀，打完一套就拉开距离</p><p>3. 合理利用变身和法术资源</p><p>4. Boss二阶段通常会有新的攻击模式，保持冷静观察</p><p>后续Boss攻略会持续更新，欢迎收藏关注！</p>`,
    category: 'gaming',
    author: '游戏老司机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20gamer%20avatar%20portrait%20with%20headphones%2C%20warm%20gaming%20room%20background%2C%20clean%20simple%20minimal%20style&width=80&height=80&seq=avatar-game-1&orientation=squarish',
    publishDate: '2024-12-11',
    views: 78200,
    replies: 1234,
    likes: 6789,
    tags: ['游戏', '黑神话悟空', '攻略', 'Boss'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 6,
    title: '考公上岸经验分享：从零基础到笔试第一的学习方法',
    excerpt: '历时8个月的系统备考，总结出行之有效的学习规划和资料推荐，送给正在备考的你。',
    content: `<p>本人2024年国考成功上岸，笔试成绩在岗位排名第一。在这里分享我的备考经验，希望能给正在努力的朋友们一些启发。</p><p><strong>备考时间规划：</strong></p><p>我的备考周期是8个月，分为三个阶段：</p><p>第一阶段（1-3月）：打基础。每天学习4-5小时，重点是行测各模块的基础知识。推荐使用粉笔APP刷题，每天至少100道。</p><p>第二阶段（4-6月）：强化提升。每天学习6-8小时，开始做套题，提升做题速度和准确率。每周至少两套完整模拟卷。</p><p>第三阶段（7-8月）：冲刺阶段。每天学习8-10小时，以真题为主，严格按照考试时间模拟。同时整理错题本，反复回顾薄弱环节。</p><p><strong>行测备考心得：</strong></p><p>言语理解：重在积累，每天阅读高质量文章，训练语感。</p><p>数量关系：掌握常见题型，熟练运用速算技巧。</p><p>判断推理：逻辑思维训练，多做题找规律。</p><p>资料分析：提分关键，练习快速定位数据和估算能力。</p><p><strong>申论备考心得：</strong></p><p>多读政府工作报告和政策文件，积累规范性表达。每周至少写两篇申论大作文，找老师批改。关注时事热点，形成自己的素材库。</p><p>备考路上很辛苦，但只要坚持就一定有收获。加油！</p>`,
    category: 'study',
    author: '追梦人小李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20student%20avatar%20portrait%20on%20simple%20light%20warm%20background%2C%20clean%20minimalist%20style&width=80&height=80&seq=avatar-study-1&orientation=squarish',
    publishDate: '2024-12-10',
    views: 35600,
    replies: 678,
    likes: 3456,
    tags: ['考公', '公务员', '备考经验', '学习方法'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 7,
    title: '那些年我们一起追过的网络神贴（搞笑合集）',
    excerpt: '整理了一些论坛上经典的搞笑神贴，笑到肚子疼！温馨提示：吃饭时慎看。',
    content: `<p>逛论坛这么多年，见过太多让人笑到停不下来的神贴。今天来盘点一波，让大家开心开心。</p><p><strong>1. "我用AI生成的头像去相亲，结果......"</strong></p><p>一位网友用AI生成了一个帅哥头像去网上相亲，聊得火热见面后——对方也是AI生成的。两人相视一笑，居然真的在一起了！</p><p><strong>2. "花3000块买了把'古董'椅子，鉴定后......"</strong></p><p>楼主在古玩市场淘了把"清朝官帽椅"，花3000请专家鉴定——结果是宜家2019年的限量款，原价299。评论区笑疯了。</p><p><strong>3. "我把公司饮水机修好了，结果CEO亲自来道谢"</strong></p><p>一位程序员分享，他顺手修了公司的饮水机，结果CEO以为是专业维修人员，给了他一张名片说"你们公司技术不错，考虑来我们这发展"。重点是——他用的工具是一支笔。</p><p><strong>4. "我妈给我介绍了个相亲对象，结果是我前女友她妈"</strong></p><p>这个帖子的戏剧性简直可以拍电视剧。楼主去了才发现对方不仅认识他，还对他了如指掌......</p><p>大家有没有遇到过什么搞笑的事情？欢迎分享，一起快乐灌水！</p>`,
    category: 'fun',
    author: '笑点低先生',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20funny%20guy%20avatar%20portrait%20laughing%20on%20simple%20warm%20background%2C%20casual%20clean%20minimal%20style&width=80&height=80&seq=avatar-fun-1&orientation=squarish',
    publishDate: '2024-12-09',
    views: 89200,
    replies: 2345,
    likes: 8900,
    tags: ['搞笑', '神贴', '灌水', '趣事'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 8,
    title: '【风光摄影】深秋川西自驾拍摄全记录',
    excerpt: '带上相机，穿越稻城亚丁、新都桥、色达，记录下了最美的川西秋色。',
    content: `<p>川西的秋天，是一场视觉的盛宴。金黄的草原、五彩的森林、巍峨的雪山、湛蓝的天空，每一帧都是大片。</p><p><strong>行程规划：</strong></p><p>Day 1-2：成都出发—康定—新都桥。新都桥被称为"摄影家的天堂"，秋天的光影尤其迷人。建议清晨和傍晚拍摄，光线最柔和。</p><p>Day 3-4：新都桥—理塘—稻城。沿途经过卡子拉山、海子山，海拔逐渐升高，景色愈发壮阔。</p><p>Day 5-6：稻城亚丁景区。牛奶海和五色海是必拍地点，建议早起徒步，避开人流高峰。</p><p>Day 7-8：稻城—色达—成都。色达五明佛学院的红房子在秋日阳光下格外震撼。</p><p><strong>摄影器材建议：</strong></p><p>广角镜头（16-35mm）拍大场景，长焦镜头（70-200mm）拍远处的雪山和人物特写。三脚架必备，日出日落时曝光时间长。</p><p><strong>拍摄心得：</strong></p><p>1. 提前用Planit等APP查看日出日落方位</p><p>2. 注意高反，不要为了拍摄过度劳累</p><p>3. 尊重当地文化，拍人文照片前先征得同意</p><p>川西的秋天太美了，已经计划明年再去！</p>`,
    category: 'photography',
    author: '快门侠',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20photographer%20avatar%20portrait%20with%20camera%20on%20warm%20simple%20background%2C%20clean%20minimal%20style&width=80&height=80&seq=avatar-photo-1&orientation=squarish',
    publishDate: '2024-12-08',
    views: 31200,
    replies: 445,
    likes: 2340,
    tags: ['摄影', '川西', '风光', '旅行'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 9,
    title: '推荐10首无限循环的华语冷门好歌',
    excerpt: '这些歌可能没有那么高的传唱度，但每首都值得反复聆听。',
    content: `<p>听腻了榜单上的热门歌曲？来换换口味，这10首冷门佳作绝对能让你耳目一新。</p><p><strong>1. 告五人 - 《带我去找夜生活》</strong></p><p>告五人虽然不是冷门乐队，但这首歌相对低调。慵懒的嗓音配上迷幻的编曲，特别适合夜晚开车时听。</p><p><strong>2. 裘德 - 《浓缩蓝鲸》</strong></p><p>金曲奖最佳新人得主，这首歌的作词堪称教科书级别。"你的温柔是巨大的蓝鲸，而我只不过是，一滴浓缩的眼泪。"</p><p><strong>3. 吕彦良 - 《飞》</strong></p><p>00后创作歌手，R&B风格让人惊艳。旋律抓耳，编曲成熟，完全不像一个新人的作品。</p><p>......（篇幅有限，完整歌单回复可见）</p><p>大家有什么私藏的冷门好歌？快来评论区互相种草吧！</p>`,
    category: 'music',
    author: '音痴不痴',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20music%20lover%20avatar%20portrait%20with%20headphones%20on%20warm%20simple%20background%2C%20clean%20minimal%20style&width=80&height=80&seq=avatar-music-1&orientation=squarish',
    publishDate: '2024-12-07',
    views: 25600,
    replies: 534,
    likes: 1890,
    tags: ['音乐', '歌曲推荐', '华语'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 10,
    title: 'Docker容器化部署全流程实战教程',
    excerpt: '从Docker基础概念到多容器编排，手把手教你将项目容器化部署。',
    content: `<p>Docker已经成为现代软件部署的标准工具。本文将通过一个实际项目，带你完整走一遍容器化部署流程。</p><p><strong>为什么需要Docker？</strong></p><p>传统的部署方式中，环境差异是最大的痛点。"在我电脑上能跑"是每个开发者的噩梦。Docker通过容器技术，将应用和依赖打包在一起，确保在任何环境都能一致运行。</p><p><strong>Dockerfile编写要点：</strong></p><p>1. 选择合适的基础镜像（推荐alpine版本，体积小）</p><p>2. 利用多阶段构建减小镜像体积</p><p>3. 合理使用.dockerignore排除不必要文件</p><p>4. 使用非root用户运行应用</p><p><strong>Docker Compose编排：</strong></p><p>对于需要多个服务（如前端+后端+数据库）的项目，Docker Compose是最佳选择。一个yml文件即可定义所有服务及其依赖关系。</p><p><strong>生产环境最佳实践：</strong></p><p>1. 使用健康检查确保服务可用</p><p>2. 配置日志驱动便于问题排查</p><p>3. 限制容器资源使用</p><p>4. 定期更新基础镜像修复安全漏洞</p><p>完整示例代码回复可见，有问题欢迎讨论！</p>`,
    category: 'tech',
    author: 'DevOps工程师小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20engineer%20avatar%20portrait%20on%20warm%20simple%20background%2C%20professional%20clean%20minimal%20style&width=80&height=80&seq=avatar-tech-3&orientation=squarish',
    publishDate: '2024-12-06',
    views: 18900,
    replies: 234,
    likes: 1234,
    tags: ['Docker', 'DevOps', '部署', '容器'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 11,
    title: '北漂5年：一个普通人的租房搬家血泪史',
    excerpt: '从城中村到合租单间再到独立公寓，分享一个北漂青年的居住进化史。',
    content: `<p>来北京5年了，前前后后搬了6次家。每次搬家都像是一场缩小版的人生重来。</p><p><strong>第一站：天通苑隔断间（1200元/月）</strong></p><p>刚来北京时预算有限，在天通苑租了一个隔断间。房间只有8平米，放下一张床和一张桌子就满了。冬天暖气不足，夏天西晒火热。但那时候刚工作，什么都觉得新鲜。</p><p><strong>第二站：回龙观次卧（1800元/月）</strong></p><p>工作半年后搬到了回龙观，和两个同事合租。有了自己的大房间，终于可以摆下一张书桌。室友们成了很好的朋友，周末一起做饭打游戏。</p><p><strong>第三站：望京主卧（2800元/月）</strong></p><p>换了工作后搬到了望京，离公司近了很多。独立卫浴，生活质量有了明显提升。</p><p>......</p><p><strong>第五站：通州一居室（4500元/月）</strong></p><p>终于有了属于自己的独立空间。虽然通勤时间变长了，但晚上关上门就是自己的世界。</p><p>租房的过程虽然辛苦，但也见证了北京这座城市的不同面貌。每一站都有它的故事。</p><p>大家在北京租房有什么难忘的经历吗？</p>`,
    category: 'life',
    author: '北漂日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20professional%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-life-2&orientation=squarish',
    publishDate: '2024-12-05',
    views: 34500,
    replies: 890,
    likes: 2345,
    tags: ['北漂', '租房', '生活', '北京'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 12,
    title: '《艾尔登法环》DLC黄金树幽影全收集攻略',
    excerpt: '包含所有新武器、护符、骨灰的详细获取位置和条件，助你完美收集。',
    content: `<p>《艾尔登法环》DLC"黄金树幽影"带来了海量新内容，这里整理了全收集攻略。</p><p><strong>新武器收集：</strong></p><p>共新增30+把武器，包括反手剑、轻大剑、投掷武器等新类型。其中"黑夜骑士大剑"需要完成特定NPC支线任务才能获取。</p><p><strong>关键道具位置：</strong></p><p>幽影树碎片分布在各地图的特定位置，收集一定数量可以强化角色。建议优先收集这些碎片来降低游戏难度。</p><p><strong>隐藏Boss触发条件：</strong></p><p>有几个隐藏Boss需要满足特定条件才会出现，比如"癫火之王"需要在夜间特定地点使用特定手势。</p><p>完整攻略持续更新中，欢迎补充和指正！</p>`,
    category: 'gaming',
    author: '魂系死忠粉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20gamer%20man%20avatar%20portrait%20on%20warm%20simple%20background%2C%20clean%20minimal%20style&width=80&height=80&seq=avatar-game-2&orientation=squarish',
    publishDate: '2024-12-04',
    views: 45600,
    replies: 678,
    likes: 3456,
    tags: ['艾尔登法环', 'DLC', '攻略', '收集'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 13,
    title: '最近看了一部超冷门但豆瓣8.5的悬疑片',
    excerpt: '西班牙小众悬疑片《看不见的客人》导演新作，反转多到让人窒息。',
    content: `<p>悬疑片爱好者看过来！最近发现一部西班牙冷门佳作，豆瓣评分8.5，看完整个人都震惊了。</p><p>影片讲述了一个看似简单的失踪案，但随着调查的深入，真相越来越扑朔迷离。导演非常擅长玩弄观众的预期，每一次你以为猜到了真相，下一秒就会被狠狠打脸。</p><p>影片的摄影也非常出色，冷色调的画面营造出极佳的悬疑氛围。配乐克制而精准，该紧张的时候让人心跳加速，该舒缓的时候又让人陷入思考。</p><p>不剧透太多，只能说最后一分钟的反转让我直接从沙发上跳了起来。喜欢悬疑片的朋友一定不要错过！</p>`,
    category: 'entertainment',
    author: '电影控小新',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20enthusiast%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-ent-2&orientation=squarish',
    publishDate: '2024-12-03',
    views: 21200,
    replies: 345,
    likes: 1567,
    tags: ['电影', '悬疑', '推荐'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 14,
    title: '程序员提升英语的实用方法（非鸡汤）',
    excerpt: '不是"每天背单词"这种废话，分享真正有效的技术英语学习方法。',
    content: `<p>作为程序员，英语水平直接影响学习效率和技术视野。这里分享几个非鸡汤的实用方法。</p><p><strong>1. 看官方文档而不是中文翻译</strong></p><p>中文翻译往往滞后且不准确。强迫自己看英文文档，一开始会很吃力，但坚持一个月就会感觉明显提升。</p><p><strong>2. 用英文写commit message和注释</strong></p><p>日常工作中刻意使用英文，哪怕不完美。实践是最好的学习方式。</p><p><strong>3. 在Stack Overflow上回答问题</strong></p><p>用英文回答技术问题，既能巩固知识又能练习表达。一开始可以回答简单的问题，逐步提升难度。</p><p><strong>4. 关注技术大牛的Twitter/Blog</strong></p><p>Dan Abramov、Kent C. Dodds等大牛的博客不仅技术含量高，文笔也很好。每天花15分钟阅读，词汇量自然增长。</p><p>记住：不需要完美，只需要进步。敢说敢写比说得对写得对更重要。</p>`,
    category: 'tech',
    author: '全栈老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20senior%20developer%20avatar%20portrait%20on%20warm%20simple%20background%2C%20clean%20minimal%20style&width=80&height=80&seq=avatar-tech-4&orientation=squarish',
    publishDate: '2024-12-02',
    views: 22100,
    replies: 312,
    likes: 1789,
    tags: ['程序员', '英语', '学习方法'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 15,
    title: '说一件你小时候做过的至今难忘的蠢事',
    excerpt: '楼主先来：小时候以为西瓜籽吃进肚子会长出西瓜，一个夏天没敢吃西瓜。',
    content: `<p>最近和朋友们聊天，发现大家小时候都做过一些现在想起来又好笑又好气的蠢事。</p><p><strong>楼主先来：</strong></p><p>大概五六岁的时候，不小心吞了一颗西瓜籽。然后想起奶奶说的"西瓜籽吃进肚子会长西瓜"，整整一个夏天没敢吃西瓜，怕给肚子里的"西瓜"浇水。</p><p>后来有一天实在忍不住吃了块西瓜，然后担心了整整一天。第二天发现没事，才恍然大悟——奶奶骗我的！</p><p><strong>网友精彩回复：</strong></p><p>@春风十里：小时候以为电视里的人能看见我，每次换衣服都躲得远远的......</p><p>@努力搬砖的小王：我把妈妈的口红当蜡笔画了满墙，然后试图用水冲掉，结果越弄越糟。</p><p>@追风少年：以为ATM机里面有个小人在数钱，每次取钱都对着取款口说"谢谢叔叔"。</p><p>大家小时候做过什么蠢事？快来分享，看看谁的童年最"精彩"！</p>`,
    category: 'fun',
    author: '童年回忆杀',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20funny%20person%20avatar%20portrait%20on%20warm%20simple%20background%2C%20humorous%20clean%20minimal%20style&width=80&height=80&seq=avatar-fun-2&orientation=squarish',
    publishDate: '2024-12-01',
    views: 67800,
    replies: 1890,
    likes: 5600,
    tags: ['童年', '趣事', '灌水', '回忆'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 16,
    title: '考研政治80+高分经验分享：这些坑千万别踩',
    excerpt: '三个月政治从60分提到82分，分享我的复习规划和避坑指南。',
    content: `<p>政治是考研中性价比最高的科目。掌握正确方法后，短时间内提分效果非常明显。</p><p><strong>复习资料推荐：</strong></p><p>核心教材：肖秀荣精讲精练+1000题。这是政治复习的"圣经"，务必吃透。</p><p>冲刺阶段：肖四肖八是必做的。大题背诵以肖四为主，同时参考腿姐（陆寓丰）的押题。</p><p><strong>时间规划：</strong></p><p>9月：精讲精练第一遍+1000题第一遍（每天2小时）</p><p>10月：精讲精练第二遍+1000题错题回顾（每天2.5小时）</p><p>11月：做真题+背诵选择题知识点（每天3小时）</p><p>12月：肖四肖八+大题背诵（每天4小时）</p><p><strong>避坑指南：</strong></p><p>1. 不要只看不练，选择题必须大量刷</p><p>2. 大题不要死记硬背，要理解答题框架</p><p>3. 时事政治注意积累，11月后集中复习</p><p>4. 不要迷信押题，基础扎实才是王道</p><p>祝大家都能取得好成绩！</p>`,
    category: 'study',
    author: '考研上岸学姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20student%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-study-2&orientation=squarish',
    publishDate: '2024-11-30',
    views: 28900,
    replies: 456,
    likes: 2340,
    tags: ['考研', '政治', '备考经验'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 17,
    title: '手机摄影入门：用手机也能拍出大片感的5个技巧',
    excerpt: '不需要昂贵的器材，掌握这些技巧，你的手机也能拍出令人惊艳的照片。',
    content: `<p>最好的相机就是你手边的那一台。现代智能手机的摄影能力已经足够强大，关键是掌握正确的技巧。</p><p><strong>技巧一：善用黄金时刻</strong></p><p>日出后一小时和日落前一小时被称为"黄金时刻"，此时的光线柔和温暖，能拍出最美的照片。尽量避免正午强光下拍摄。</p><p><strong>技巧二：学会构图法则</strong></p><p>三分法则是最基础也最实用的构图方法。打开手机相机的网格线，将主体放在交叉点上，画面会立即提升档次。</p><p><strong>技巧三：注意前景运用</strong></p><p>有意识地加入前景元素（如树叶、窗户、门框等），可以让照片更有层次感和深度。</p><p><strong>技巧四：利用引导线</strong></p><p>道路、栏杆、河流等线条可以引导观众的视线，让照片更有方向感和故事性。</p><p><strong>技巧五：后期不是作弊</strong></p><p>适当后期是摄影的重要环节。推荐Snapseed和Lightroom Mobile，调整曝光、对比度和饱和度即可，不要过度修图。</p><p>拿起手机去拍吧！好照片就在你身边。</p>`,
    category: 'photography',
    author: '手机摄影师阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20photographer%20man%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-photo-2&orientation=squarish',
    publishDate: '2024-11-29',
    views: 19800,
    replies: 267,
    likes: 1456,
    tags: ['摄影', '手机摄影', '技巧'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 18,
    title: '周杰伦新专辑深度乐评：那个熟悉的周氏风格回来了',
    excerpt: '时隔多年，周杰伦终于发新专辑了！逐首分析新歌的编曲特点和歌词意境。',
    content: `<p>等了这么久，周杰伦的新专辑终于来了。第一时间听完后，那种熟悉的感觉让人热泪盈眶。</p><p><strong>专辑整体评价：</strong></p><p>这张专辑延续了周杰伦标志性的"周氏曲风"，但又融入了一些新的音乐元素。编曲上更加成熟精致，方文山的歌词依然充满诗意和想象力。</p><p><strong>推荐曲目：</strong></p><p>主打歌一开头的钢琴前奏就让人起了鸡皮疙瘩，副歌部分的旋律走向非常"周杰伦"。第二主打则更加实验性，融合了电子和古典元素。</p><p><strong>乐评人说：</strong></p><p>很多乐评人认为这是周杰伦近年来最用心的一张专辑。没有刻意讨好市场，而是回归音乐本身。作为一个听了周杰伦二十年的老歌迷，这张专辑让我重新找到了第一次听《Jay》时的感动。</p><p>大家听了新专辑吗？最喜欢哪首歌？</p>`,
    category: 'music',
    author: '老周铁粉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20music%20fan%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-music-2&orientation=squarish',
    publishDate: '2024-11-28',
    views: 34500,
    replies: 678,
    likes: 3456,
    tags: ['音乐', '周杰伦', '专辑', '乐评'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 19,
    title: 'AI绘画工具Midjourney V6使用技巧大全',
    excerpt: '从提示词工程到参数调优，全面掌握Midjourney V6的高阶用法。',
    content: `<p>Midjourney V6在图像质量上又有了质的飞跃。本文整理了最实用的使用技巧。</p><p><strong>提示词工程基础：</strong></p><p>一个好的提示词需要包含：主体描述、风格/媒介、光照、构图、画质参数。例如："A serene Japanese garden at golden hour, soft mist floating above the pond, photorealistic, 8K, shot on Canon R5"</p><p><strong>参数调优指南：</strong></p><p>--ar（宽高比）：根据用途选择，社交媒体适合1:1或4:5，横版适合16:9</p><p>--stylize（风格化）：值越高越艺术化，越低越接近提示词字面意思</p><p>--chaos（多样性）：控制生成结果的多样性</p><p>--weird（怪异度）：V6新增，控制图像的创意程度</p><p><strong>进阶技巧：</strong></p><p>1. 图像混合：使用/blend命令融合多张参考图</p><p>2. 角色一致性：通过seed值和详细的面部描述保持角色一致</p><p>3. 风格迁移：用describe命令分析参考图的风格特征</p><p>AI绘画工具发展太快了，保持学习才能跟得上！</p>`,
    category: 'tech',
    author: 'AI画师阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20AI%20artist%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-tech-5&orientation=squarish',
    publishDate: '2024-11-27',
    views: 31200,
    replies: 423,
    likes: 2340,
    tags: ['AI', 'Midjourney', '绘画', '教程'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 20,
    title: '30岁转行做自由职业者的真实体验',
    excerpt: '辞掉月薪2万的工作，成为一名自由职业者，分享半年来的真实感受。',
    content: `<p>今年3月，我做了一个让周围人都不理解的决定——辞掉稳定的互联网工作，成为一名自由职业者。</p><p><strong>为什么要转行？</strong></p><p>不是因为工资低，是因为看不到未来。每天996，做着重复的工作，感觉自己像一颗螺丝钉。30岁的关口，突然很害怕就这样过一辈子。</p><p><strong>自由职业的真相：</strong></p><p>1. 收入不稳定：好的月份能到之前的1.5倍，差的月份只有一半</p><p>2. 需要极强的自律：没人管你，但也没人替你兜底</p><p>3. 社交圈缩小：原来每天能见几十个同事，现在一周见不了几个人</p><p>4. 但真的很自由：可以决定什么时间工作，在哪里工作</p><p><strong>给想转行的人的建议：</strong></p><p>1. 至少有6个月的生活储备金</p><p>2. 先兼职尝试，确认自己适合再说</p><p>3. 建立多元化的收入来源</p><p>4. 保持学习和社交，不要与社会脱节</p><p>自由职业不是逃避工作的方式，而是另一种更主动的生活方式。</p>`,
    category: 'life',
    author: '自由之路',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20freelancer%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-life-3&orientation=squarish',
    publishDate: '2024-11-26',
    views: 42300,
    replies: 890,
    likes: 4567,
    tags: ['自由职业', '转行', '职业规划'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 21,
    title: '【福利】B站大会员免费领取方式汇总（持续更新）',
    excerpt: '整理了目前所有可以免费获取B站大会员的渠道和方法。',
    content: `<p>作为一个重度B站用户，收集了不少免费获取大会员的渠道，分享给大家。</p><p><strong>长期有效渠道：</strong></p><p>1. 中国移动/联通/电信积分兑换</p><p>2. 银行卡权益兑换（招行、建行等）</p><p>3. 支付宝会员积分兑换</p><p><strong>限时活动：</strong></p><p>1. 新用户首月特惠</p><p>2. 节假日活动赠送</p><p>3. 特定番剧追番活动</p><p>会持续更新新发现的渠道，建议收藏。如果大家有其他渠道，欢迎在评论区分享！</p>`,
    category: 'fun',
    author: '白嫖达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-fun-3&orientation=squarish',
    publishDate: '2024-11-25',
    views: 56700,
    replies: 1234,
    likes: 4500,
    tags: ['B站', '福利', '会员'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 22,
    title: '塞尔达传说新作偷跑信息整理与分析',
    excerpt: '整理了网络上关于塞尔达新作的所有偷跑信息，分析可信度。',
    content: `<p>最近关于塞尔达传说的偷跑信息满天飞，真假难辨。这里做个全面整理。</p><p><strong>已确认的信息：</strong></p><p>任天堂官方确认正在开发塞尔达系列新作，但未透露具体细节。发布会预计在明年年初。</p><p><strong>比较可信的传闻：</strong></p><p>1. 新作将回归传统迷宫设计（多个消息源一致）</p><p>2. 塞尔达公主可能成为可操作角色</p><p>3. 地图规模比旷野之息更大</p><p><strong>不太可信的传闻：</strong></p><p>1. 支持VR模式</p><p>2. 2024年圣诞节发售</p><p>3. 将登陆PC平台</p><p>总之还是等官方消息，不要过度期待以免失望。</p>`,
    category: 'gaming',
    author: '任豚一枚',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20gamer%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-game-3&orientation=squarish',
    publishDate: '2024-11-24',
    views: 34500,
    replies: 567,
    likes: 2340,
    tags: ['塞尔达', '游戏', '传闻'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 23,
    title: 'CPA备考全攻略：科目搭配与时间规划',
    excerpt: '作为考证难度天花板，CPA需要科学的备考策略。分享科目搭配建议和复习节奏。',
    content: `<p>CPA（注册会计师）被称为"天下第一考"，难度和含金量都是顶级的。</p><p><strong>科目搭配建议：</strong></p><p>第一年：会计+税法（最合理的起步组合）</p><p>第二年：审计+经济法</p><p>第三年：财管+战略</p><p>会计是CPA的基础，建议第一年拿下。税法和会计关联度高，一起学习效率更高。</p><p><strong>时间投入：</strong></p><p>每科建议投入300-400小时。会计和审计需要的时间最长，经济法和战略相对较少。</p><p><strong>复习资料推荐：</strong></p><p>教材以中注协官方教材为准。辅导书推荐东奥或中华的系列教材。真题至少做3遍。</p><p>CPA备考是一场持久战，坚持不懈最重要！</p>`,
    category: 'study',
    author: 'CPA考证人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-study-3&orientation=squarish',
    publishDate: '2024-11-23',
    views: 18900,
    replies: 345,
    likes: 1678,
    tags: ['CPA', '考证', '会计'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 24,
    title: '用手机录了一段翻唱《平凡之路》，大家听听怎么样？',
    excerpt: '业余爱好，不专业，轻喷。设备和环境都有限，大家凑合听。',
    content: `<p>周末心血来潮，用手机录了一段朴树的《平凡之路》。</p><p>设备：iPhone 15 Pro Max + 原装耳机麦克风</p><p>后期：用库乐队简单修了一下音准和混响</p><p>唱功有限，纯粹是自娱自乐。但这首歌真的太有共鸣了——"我曾经跨过山和大海，也穿过人山人海"——每次唱到这里都有种说不出的感动。</p><p>大家有什么喜欢的歌也来分享一下吧！想听大家唱歌！</p>`,
    category: 'music',
    author: '浴室歌手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20singer%20avatar%20portrait%20on%20warm%20minimal%20background%2C%20clean%20simple%20style&width=80&height=80&seq=avatar-music-3&orientation=squarish',
    publishDate: '2024-11-22',
    views: 16700,
    replies: 456,
    likes: 1234,
    tags: ['翻唱', '音乐', '平凡之路'],
    isHot: false,
    isPinned: false,
  },
];